export const DEFAULT_CONTENT = {
    hero_badge: "Created by dealers, for dealers",
    hero_line_1: "Built by dealers.",
    hero_line_2: "Accepted at the",
    hero_line_3: "service counter.",
    hero_subtext:
        "AdvantaShield is the extended car warranty rebuilt as a subscription — engineered by dealership service directors, sold on the showroom floor, and honored at the service counter. Not a $3,000 lump sum.",
    manifesto_eyebrow: "The Manifesto — Chapters 01 to 04",
    manifesto_heading_a: "Why the counter says yes to us —",
    manifesto_heading_b: "and no to them.",
    plans_eyebrow: "The Program",
    plans_heading_a: "One subscription.",
    plans_heading_b: "Three wins.",
    plans_note:
        "No prices on this page — on purpose. Your rate is built on your vehicle's year, make, model, and mileage, and quotes take under a minute. No robocalls. Ever.",
    compare_eyebrow: "No names needed. You know who we mean.",
    compare_heading_a: "The most advertised name in car warranties",
    compare_heading_b: "isn't welcome at most service counters anymore.",
    compare_subtext:
        "We were built by the people who turn those contracts away. Here's the honest scoreboard.",
    compare_closing_a: "We don't have to name them.",
    compare_closing_b: "Their product already got itself shown the door.",
    dealers_eyebrow: "For Dealerships",
    dealers_heading_a: "Sell AdvantaShield",
    dealers_heading_b: "at your dealership.",
    dealers_subtext:
        "Stop watching third-party warranty checks walk out the door. AdvantaShield is the coverage your store can sell on the showroom floor and honor in your service lane — one product, two profit centers.",
    testimonials_eyebrow: "From the Service Lane",
    testimonials_heading_a: "The people behind the counter",
    testimonials_heading_b: "said it best.",
    faq_eyebrow: "Questions, Answered",
    faq_heading_a: "Everything the counter",
    faq_heading_b: "already knows.",
    faq_subtext:
        "Straight answers on acceptance, claims, eligibility, and how a coverage subscription actually works.",
    footer_cta_eyebrow: "Ready when you are",
    footer_cta_heading_a: "Your dealer already trusts us.",
    footer_cta_heading_b: "Now you can too.",
    footer_cta_note: "Under a minute. No robocalls. Ever.",
    footer_blurb:
        "AdvantaShield is the extended car warranty rebuilt as a monthly subscription — a vehicle service contract created by dealers, for dealers, accepted at dealership service counters and sold on the showroom floor. Cancel anytime.",
};

export const CONTENT_GROUPS = [
    {
        title: "Hero",
        fields: [
            { key: "hero_badge", label: "Badge pill text" },
            { key: "hero_line_1", label: "Headline — line 1" },
            { key: "hero_line_2", label: "Headline — line 2" },
            { key: "hero_line_3", label: "Headline — line 3 (blue accent)" },
            { key: "hero_subtext", label: "Subtext", multiline: true },
        ],
    },
    {
        title: "Manifesto",
        fields: [
            { key: "manifesto_eyebrow", label: "Eyebrow" },
            { key: "manifesto_heading_a", label: "Heading (white)" },
            { key: "manifesto_heading_b", label: "Heading (blue accent)" },
        ],
    },
    {
        title: "Program Section",
        fields: [
            { key: "plans_eyebrow", label: "Eyebrow" },
            { key: "plans_heading_a", label: "Heading (white)" },
            { key: "plans_heading_b", label: "Heading (blue accent)" },
            { key: "plans_note", label: "Note under the boxes", multiline: true },
        ],
    },
    {
        title: "Comparison",
        fields: [
            { key: "compare_eyebrow", label: "Eyebrow" },
            { key: "compare_heading_a", label: "Heading (white)" },
            { key: "compare_heading_b", label: "Heading (blue accent)" },
            { key: "compare_subtext", label: "Subtext", multiline: true },
            { key: "compare_closing_a", label: "Closing line (white)" },
            { key: "compare_closing_b", label: "Closing line (muted)" },
        ],
    },
    {
        title: "Dealer Section",
        fields: [
            { key: "dealers_eyebrow", label: "Eyebrow" },
            { key: "dealers_heading_a", label: "Heading (white)" },
            { key: "dealers_heading_b", label: "Heading (blue accent)" },
            { key: "dealers_subtext", label: "Subtext", multiline: true },
        ],
    },
    {
        title: "Testimonials",
        fields: [
            { key: "testimonials_eyebrow", label: "Eyebrow" },
            { key: "testimonials_heading_a", label: "Heading (white)" },
            { key: "testimonials_heading_b", label: "Heading (blue accent)" },
        ],
    },
    {
        title: "FAQ",
        fields: [
            { key: "faq_eyebrow", label: "Eyebrow" },
            { key: "faq_heading_a", label: "Heading (white)" },
            { key: "faq_heading_b", label: "Heading (blue accent)" },
            { key: "faq_subtext", label: "Subtext", multiline: true },
        ],
    },
    {
        title: "Footer",
        fields: [
            { key: "footer_cta_eyebrow", label: "CTA eyebrow" },
            { key: "footer_cta_heading_a", label: "CTA heading (white)" },
            { key: "footer_cta_heading_b", label: "CTA heading (muted)" },
            { key: "footer_cta_note", label: "CTA note" },
            { key: "footer_blurb", label: "Brand blurb", multiline: true },
        ],
    },
];
